import {connect} from 'react-redux';
import ReportsContent from '../components/ReportsContent';
import {loadReports, loadReportById} from '../actions';
import {mapReportsToProps} from "../selectors";

export default connect(mapReportsToProps, {loadReports, loadReportById})(ReportsContent);
